import * as angular from 'angular';
import * as moment from 'moment';

import { isCurlErrorLogMessage } from '@app/logs/constants/logs.constants';
import { MODULE_NAME } from './config/constants';

// Filter an array by the intersection of words present in filter_text
angular.module(MODULE_NAME).filter('filterSearch', ['$filter', function($filter){
	return function(items, text){
		if (!text || text.length === 0)
		return items;

		// split search text on space
		var searchTerms = text.split(' ');

		// search for single terms.
		// this reduces the item list step by step
		searchTerms.forEach(function(term) {
		if (term && term.length)
			items = $filter('filter')(items, term);
		});

		return items
	};
}]);

// Convert new lines to <br>
angular.module(MODULE_NAME).filter("convertNewLines", ['$filter', function($filter) {
	return function(data) {
		if (!data)
			return data;
		return data.replace(/\n/g, "<br>");
	};
}]);

// Filter used for ng-bind-html. Caller must escape any untrusted/log-sourced text first
// (see logMessage + $filter('escapeHtml')); trustAsHtml bypasses Angular's built-in sanitization.
angular.module(MODULE_NAME).filter('unsafe', ['$sce', function ($sce) {
    return function (val) {
        return $sce.trustAsHtml(val);
    };
}]);

// HTML-escape filter for embedding dynamic log fields in trusted templates.
angular.module(MODULE_NAME).filter('esc', ['$filter', function ($filter) {
    return function (val) {
        if (val === null || val === undefined) {
            return '';
        }
        return $filter('escapeHtml')(String(val));
    };
}]);

angular.module(MODULE_NAME).filter('percentage', ['$filter', function ($filter) {
	return function (input, decimals) {
		return $filter('number')(input * 100, decimals) + '%';
	};
}]);

angular.module(MODULE_NAME).filter('orderObjectBy', function() {
	return function(items, field, reverse) {
		var filtered = [];
		angular.forEach(items, function(item) {
			filtered.push(item);
		});
		filtered.sort(function (a, b) {
			if (a[field]==b[field])
				return 0;
			else
				return (a[field] > b[field] ? 1 : -1);
		});
		if(reverse) filtered.reverse();
			return filtered;
	};
});

angular.module(MODULE_NAME).filter('moment', function() {
	return function(dateString, format) {
		switch(format) {
			case 'monthtime': format = 'MMMM Do, YYYY, h:mma'; break; // June 6th, 2019, 10:19pm
			case 'relative': return moment(dateString).fromNow(); // 2 hours ago
		}

		return moment(dateString).format(format);
	}
});

angular.module(MODULE_NAME).filter('prettyJSON', function () {
	return function(json) {
		try {
			if (typeof json !== 'object') {
				json = JSON.parse(json);
			}

			return JSON.stringify(json, null, '  ');
		} catch(e) {
			return 'Invalid JSON';
		}
	};
});

angular.module(MODULE_NAME).filter('NonprintableCharacters', ['fdxUtils', function(fdxUtils) {
	return function(str, skip_escape) {
		// Sanitize HTML so we can render nonprintable characters but not HTML in the string
		if (skip_escape !== true) {
			str = fdxUtils.escapeHTML(str);
		}

		// Reference: https://github.com/slevithan/xregexp/blob/2b652889fc14524d20f85604f291f725347f8033/src/addons/unicode-categories.js#L26-L31
		var regex = /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g;

		return str.replace(regex, function(res) {
			return '<span class="nonprintable-character">' + res + '</span>';
		});
	};
}]);
angular.module(MODULE_NAME).filter('readableCron', function() {
	return function(str) {
		if(!str) {
			return 'Never';
		}

		return cronstrue.toString(str);
	};
});

/* eslint-disable no-var, quotes, @stylistic/quotes */
angular.module(MODULE_NAME).filter('logMessage', ['$filter', function($filter) {
	return function(log, message_override) {
		if(!log || !log.message) {
			return message_override || 'Missing log!';
		}

		var esc = $filter('esc');

		var get_template_cb = {
			db_import : function (log) {
				return "Finished Importing <strong>"+$filter('number')(log.data.sku_count,0)+"</strong> Rows";
			},
			download : function (log) {
				return "Finished Downloading Import File";
			},
			source_file_field_missing : function (log) {
				return "<span class='error_color'>The import file was expected to have the following source field:\"" + esc(log.data.header_field_name) +"\", but it was missing.</span>";
			},
			no_fields_for_tmp_table : function (log) {
				return "<span class='error_color'>Feedonomics could not infer any shared characteristics between this join import and any other import in this database.</span>";
			},
			xml_to_csv : function (log) {
				return "<span class='error_color'>" +
					"The XML file for this import was invalid<br>" +
					"The first encountered error:<br>" +
					"<pre>" +
					esc(log.data.first_xml_error) +
					"</pre>" +
					"</span>";
			},
			xml_to_csv_download : function (log) {
				return "<span class='error_color'>The XML Parsing Service Was Temporarily Unavailable, so the import was stopped.</span>";
			},
			import_missing_header : function (log) {
				return "<span class='error_color'>The import file is missing a header row.</span>";
			},
			export : function(log) {
				return "Finished Exporting <strong>"+$filter('number')(log.data.total_count,0)+"</strong> Rows"
			},
			amazon_api_error : function(log) {
				return "<span class='error_color'>There was an issue with the Amazon API.</span>"
			},
			export_local : function(log) {
				return "Ran Local Export with <strong>"+$filter('number')(log.data.total_count,0)+"</strong> Rows"
			},
			data_governance_prevent_export : function(log) {
				var return_message = "<span class='error_color'>A data governance query has prevented your export<br><br>";
				Object.keys(log.data.data_governance_queries).forEach(function (key) {
					if (log.data.data_governance_queries[key].criteria_met) {
						return_message
							+= "<code style=\"display:block;white-space:pre-wrap;\">"
							+ esc(log.data.data_governance_queries[key].selector)
							+ "</code> had ";
						if (log.data.data_governance_queries[key].comparison_operator === '>') {
							return_message += 'more';
						} else {
							return_message += 'less';
						}
						return_message
							+= ' than '
							+ esc($filter('number')(log.data.data_governance_queries[key].threshold_count,0));
						if (log.data.data_governance_queries[key].threshold_type === 'percent') {
							return_message += '% of';
						}
						return_message += " rows, so exporting was halted.<br><br>";
					}
				});
				return return_message;
			},
			data_governance_alert : function(log) {
				var return_message = "<span class='warning_color'>A data governance query was triggered<br><br>";
				Object.keys(log.data.data_governance_queries).forEach(function (key) {
					if (log.data.data_governance_queries[key].criteria_met) {
						return_message
							+= "<code class='warning_color' style=\"display:block;white-space:pre-wrap;\">"
							+ esc(log.data.data_governance_queries[key].selector)
							+ "</code> had ";
						if (log.data.data_governance_queries[key].comparison_operator === '>') {
							return_message += 'more';
						} else {
							return_message += 'less';
						}
						return_message
							+= ' than '
							+ esc($filter('number')(log.data.data_governance_queries[key].threshold_count,0));
						if (log.data.data_governance_queries[key].threshold_type === 'percent') {
							return_message += '% of';
						}
						return_message += " rows.<br><br>";
					}
				});
				return return_message;
			},
			data_override_unique_violation : function(log) {
				return "<span class='error_color'>Override violation : `" + esc(log.data.field) + "` is not a unique field</span>";
			},
			export_threshold_violation : function(log) {
				return "<span class='error_color'>We expected more than " + esc($filter('number')(log.data.threshold,0)) + " rows, but detected only " + esc(log.data.total_count) + " rows.<br/></span>";
			},
            export_empty_violation : function(log) {
							return "<span class='error_color'>Empty Summary Error: There are 0 rows to summarize/calculate deltas.</span><br/>";
            },
			update_threshold_violation : function(log) {
				return "<span class='error_color'>We expected to update at least " + esc($filter('number')(log.data.update_threshold,0)) + " rows, but updated only " + esc(log.data.sku_count) + " rows.<br></span>";
			},
			load_threshold_violation : function(log) {
				return "<span class='error_color'>We expected to load at least " + esc(log.data.load_threshold) + " rows, but loaded only " + esc(log.data.sku_count) + " rows.<br></span>";
			},
			invalid_xml_path : function(log) {
				return "<span class='error_color'>There was an invalid XML path: `" + esc(log.data.export_field.export_field_name) + "`</span>";
			},
			transformer_fail : function(log) {
				var return_message =
					"<span class='error_color'>Invalid transformation: ";

				if (log.data.transformer) {
					return_message +=
						esc(log.data.transformer.field_name) + "<br>"
						+ "if: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.selector) + "</code>"
						+ "then: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.transformer) + "</code>";

				} else if (log.data.old_message) {
					return_message += esc(log.data.old_message);
				}

				if (typeof(log.data.error_details) !== 'undefined') {
					return_message += "<br>Specific Error: " + esc(log.data.error_details);
				}

				return_message += "</span>";

				return return_message;
			},
			transformer_lex : function(log) {
				var return_message =
					"<span class='error_color'>There was an issue lexing a transformer for field `"
					+ esc(log.data.transformer.field_name) + "`<br>"
					+ "if: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.selector) + "<br>"
					+ "then: " + esc(log.data.transformer.transformer)
					+ "</span>";
				return return_message;
			},
			transformer_parse : function(log) {
				var return_message =
					"<span class='error_color'>There was an issue parsing a transformer for field \"" + esc(log.data.transformer.field_name) + "\" <br>"
					+ "if: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.selector) + "</code>"
					+ "then: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.transformer) + "</code>"
					+ "error: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.parse?.value) + "</code>"
					+ "</span>";
				return return_message;
			},
			transformer_create : function(log) {
				var return_message =
					"<span class='error_color'>There was an issue creating a transformer for field \"" + esc(log.data.transformer.field_name) + "\" <br>"
					+ "if: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.selector) + "</code>"
					+ "then: <code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.transformer.transformer) + "</code>"
					+ "</span>";
				return return_message;
			},
			curl_error : function(log) {
				var return_message = "<span class='error_color'>";
					return_message +=
						"We could not communicate to the receiving server.";

				if(log.data.curl_readable_messages) {
					if(log.data.curl_readable_messages.short_message) {
						return_message += "<br>" + esc(log.data.curl_readable_messages.short_message);
					}

					if(log.data.curl_readable_messages.action_message) {
						return_message += "<br>" + esc(log.data.curl_readable_messages.action_message);
					}
				}

				return_message += "<br>The specific error was:<br>(" + esc(log.data.curl_errno) + ") " + esc(log.data.curl_error) + "</span>";

				return return_message;
			},
			export_webhook_error: function(log) {
				var exportDbId = esc(log.data.export?.db_id);
				var exportId = esc(log.data.export?.id);
				var return_message = '' +
					'<span class="error_color">' +
					'  <strong>Export:</strong> <a href="/app/#/'+ exportDbId +'/exports?export_id='+ exportId +'">'+ esc(log.data.export?.name) +'</a>' +
					'  <br />' +
					'  <strong>Error:</strong> <span style="white-space: pre-wrap">'+ esc(log.data.message ? log.data.message.trim() : 'N/A') +'</span>' +
					'</span>';

				return return_message;
			},
			export_webhook_log: function(log) {
				var payloads = [];

				if (!log.data || !Array.isArray(log.data)) {
					log.data = [];
				}

				var message_class = 'error_color';
				log.data.forEach(function(row) {
					payloads.push('<div class="form-control webhook-log" style="height: auto; white-space: pre-wrap;">' + esc($filter('prettyJSON')(JSON.parse(row.payload))) + '</div>');

					var data_payload = JSON.parse(row.payload);
					// export_webhook_log has a special circumstance where it should not be classified as an error.
					if((data_payload.status ?? 'bad') == 'ok' && (data_payload.message ?? 'bad') == 'metrics') {
						message_class = '';
					}
				});

				if (log.data.length === 0) {
					return 'Pending response from Export';
				}

				var return_message = '' +
					'<span class="' + message_class + '">' +
					'  <strong>Export:</strong> ' +
					'  <a href="/app/#/'+ esc(log.data[0].export.db_id) +'/exports?export_id='+ esc(log.data[0].export.id) +'">'+ esc(log.data[0].export.name) +'</a>' +
					'  <br />' +
					'  <strong>Payloads:</strong>' +
					payloads.join('<br />') +
					'</span>';

				return return_message;
			},
			download_limit : function (log) {
				//"The import file exceeded the download file size limit of {$data['import']['limits']['import_file.size']}"
				var return_message =
					"<span class='error_color'>The import file exceeded the download file size limit of "+ esc(log.data.download_limit) +"</span>"
				return return_message;
			},
			empty_file : function(log) {
				var return_message =
					"<span class='error_color'>"
					+ "We attempted to download but the server responded with an empty file.<br>"
					+ "</span>";
				return return_message;
			},
			gzip_fail : function(log) {
				var return_message =
					"<span class='error_color'>"
					+ "The given gzip file may be corrupted.<br>"
					+ "</span>";
				return return_message;
			},
			deduplicate_field_error : function(log) {
				var return_message =
					"<span class='error_color'>"
					+ "Export failed: \"" + esc(log.data.field) + "\" is not a valid export field to deduplicate on.<br>"
					+ "</span>";
				return return_message;
			},
			create_temporary_table_fail : function(log) {
				return "<span class='error_color'>There was an error creating the join table:<code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.mysqli_error) + "</code></span>"
			},
			dgq_parse_fail : function(log) {
				return "<span class='error_color'>There was an error exporting. The data governance query failed to parse: <br><code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.parse?.value) + "</code></span>"
			},
			dgq_lex_fail : function(log) {
				return "<span class='error_color'>There was an error exporting. The data governance query failed to lex: <br><code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.lex?.value) + "</code></span>"
			},
			dgq_create_fail : function(log) {
				return "<span class='error_color'>There was an error exporting. The data governance query failed to create: <br><code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.data_governance_query.selector) + "</code></span>"
			},
			dgq_call_fail : function(log) {
				return "<span class='error_color'>There was an error exporting. The data governance query failed to call: <br><code style=\"display:block;white-space:pre-wrap;\">" + esc(log.data.data_governance_query.selector) + "</code></span>"
			},
			preprocess_error : function (log) {
				var return_message =
					"<span class='error_color'>Preprocessing failed.<br><br>The specific error was `"+ esc(log.data.preprocess_error.message) +"`.<br>Message: \""+ esc(log.data.preprocess_error.display_message) +"\"</span>"
				return return_message;
			},
		};

		if (typeof log.data === 'string') {
			try {
				log.data = JSON.parse(log.data);
			} catch(e) {
				// Silent
			}
		}

		const templateKey = isCurlErrorLogMessage(log.message) ? 'curl_error' : log.message;
		return get_template_cb[templateKey] ? get_template_cb[templateKey](log) : esc(log.message);
	};
}]);
/* eslint-enable no-var, quotes, @stylistic/quotes */

angular.module(MODULE_NAME).filter('prettyHTML', function() {
	return function(html) {
		if(typeof html  !== 'string') {
			return html;
		}
		if(html.startsWith('<html>') === false) {
			return html;
		}
		var tab = '\t';
		var result = '';
		var indent= '';

		html.split(/>\s*</).forEach(function(element) {
			if (element.match( /^\/\w/ )) {
				indent = indent.substring(tab.length);
			}

			result += indent + '<' + element + '>\r\n';

			if (element.match( /^<?\w[^>]*[^\/]$/ )) {
				indent += tab;
			}
		});
		return result.substring(1, result.length-3);
	}
})

angular.module(MODULE_NAME).filter('dbGroupDisplayName', function () {
	return function(dbGroup) {
		if (!angular.isObject(dbGroup)) {
			return '';
		}
		let group_name = dbGroup.name;
		if (dbGroup.id > 0) {
			group_name += ' (ID ' + dbGroup.id + ')';
		}
		return group_name;
	}
})
